type OwnProps = {
  nativeAppCapabilityOptions: string[];
  currentNativeAppCapabilities?: string;
};

export default function NativeAppCapabilitiesSection({
  nativeAppCapabilityOptions,
  currentNativeAppCapabilities
}: OwnProps) {
  return (
    <div>
      {nativeAppCapabilityOptions.map(nativeAppCapability => {
        const isSet = Boolean(
          currentNativeAppCapabilities?.includes(nativeAppCapability)
        );

        return (
          <label key={nativeAppCapability} className="flex gap-8 text-white">
            <input
              type="checkbox"
              name="native-app-capability"
              value={nativeAppCapability}
              disabled={isSet}
              defaultChecked={isSet}
            />
            <span>{nativeAppCapability}</span>
          </label>
        );
      })}
    </div>
  );
}
